import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-outlined p-4"
}
const _hoisted_2 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_6 = { class: "form-label" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_12 = { class: "form-label" }
const _hoisted_13 = { class: "font-semibold" }
const _hoisted_14 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_15 = { class: "form-label" }
const _hoisted_16 = { class: "font-semibold" }
const _hoisted_17 = { class: "flex items-center justify-between border-gray-300 border-b px-2 mb-5" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "**********", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, { to: "/account/change-name" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('word.name')), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.user.name ?? _ctx.t('word.none')), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account/change-nick-name" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('word.nick_name')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.user.nick_name ?? _ctx.t('word.noname')), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account/change-email" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('word.email')), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.user.email ?? _ctx.t('word.none')), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account/change-prefectures" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('word.prefectures')), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.user.pref_name), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account/change-tradingview-name" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t('word.tradingview_name')), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user.tradingview_name ?? _ctx.t('word.none')), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/account/change-password" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.t('word.password')), 1),
                _hoisted_19
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-6",
                  path: _ctx.mdiChevronRight
                }, null, 8, ["path"])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}